import {mapGetters} from "vuex"
export const userPermission = {
    computed: {
        ...mapGetters('common', {
            getUserIdentity: 'getUserIdentity'
        }),
    },
    methods: {
        // 数据跨境=》判断当前用户（mainland、hk/Macau、overseas）所处IP位置下的权限
        hasPermission(params) {
            // return !(this.getUserIdentity && this.getUserIdentity.length > 0 && this.getUserIdentity.indexOf(params) !== -1)    // 结果反过来，调试用
            return this.getUserIdentity && this.getUserIdentity.length > 0 && this.getUserIdentity.indexOf(params) !== -1
        }
    }
}